<template>
  <div style="display: inline;">
    <span
      class="conversation__apartment apartment-label"
      v-if="getApartment"
      >{{ getApartment }}
    </span>
    <span
      v-if="getSecondaryRole && showSecondaryRole"
      class="conversation__apartment apartment-label"
      >{{ getSecondaryRole }}
    </span>
    <span class="quick-link__arrow" v-if="(roles.includes('propertyManager') || roles.includes('maintenanceManager')) && (partnerCompanies !== '')">
        <i class="fal" :class="{ 'fa-chevron-up': isRotate, 'fa-chevron-down': !isRotate }" @click="toggleArrowBtn()"></i>
    </span>
    <div class="housingContent" v-if="housingContent">{{ partnerCompanies }}</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { formatApartmentGroup } from "@/utils/ApartmentUtil";
export default {
  name:"CommunityUserTagLabel",
  data() {
    return {
      housingContent: false,
      isRotate: false,
      hCName: ""
    }
  },
  methods: {
    toggleArrowBtn: function() {
      this.isRotate = !this.isRotate;
      this.housingContent = !this.housingContent;
    },
    getTag: function() {
      let tag = this.apartment;
      if (this.externalName) tag = `${this.externalName} (${this.apartment})`;
      if (this.aptGroup) tag += ` ${formatApartmentGroup(this.aptGroup)}`;
      return tag;
    },
  },
  props: {
    roles: {type: Array},
    apartment: {type: String},
    aptGroup: {type: String},
    externalName: {type: String},
    conversationType: {type: String, default: 'public'}, //area/public
    projectId: {type: String},
    partnerCompanies: {type: String},
    showSecondaryRole: {type: Boolean, default: false}
  },
  computed: {
    ...mapGetters(['getAreaNameByExtId']),
    getApartment() {
      if (Array.isArray(this.roles) && this.roles.length) {
        if (
          this.roles.includes('admin') ||
          this.roles.includes('yitAdmin') ||
          this.roles.includes('yitMarketing') ||
          this.roles.includes('yitBusinessAdmin') ||
          this.roles.includes('yitProject') ||
          this.roles.includes('yitProjectInternal')
        ) {
          return "YIT";
        } else if (this.roles.includes('propertyManager')) {
          return this.$t('user.admin.role.rolePropertyManager');
        } else if (this.roles.includes('maintenanceManager') || this.roles.includes('ceeMaintenanceManager')) {
          return this.$t('user.admin.role.roleMaintenanceManager');
        } else if (this.roles.includes('boardMember') || this.roles.includes('chairman') || this.roles.includes('ceeBoardMember')) {
          if (this.conversationType === 'area') {
            return this.apartment !== '-' ? this.getAreaNameByExtId(this.projectId) : this.getTag();
          }
          return this.roles.includes('ceeBoardMember')
            ? this.$t('community.label.boardMember')
            : this.$t('community.label.administration');

        } else if (this.roles.includes('habManager')) {
          return this.$t('user.admin.role.roleHabManager');
        } else if (this.roles.includes('rentalManager')) {
          return this.$t('user.admin.role.roleRentalManager');
        } else {
          return this.getTag();
        }
      } else if (this.apartment) {
        if (this.conversationType === 'area') {
          return this.apartment !== '-' ? this.getAreaNameByExtId(this.projectId) : this.getTag();
        } else {
          const adminRoles = [
            'community.label.administration',
            'user.admin.role.rolechairman',
            'user.admin.role.roleboardmember',
            'user.admin.role.rolepropertymanager',
            'user.admin.role.rolemaintenancemanager',
          ];
          return adminRoles.includes(this.apartment.toString().toLowerCase())
            ? this.$t(this.apartment)
            : this.getTag();
        }
      } else if (this.conversationType === 'area') {
        return this.getAreaNameByExtId(this.projectId);
      }

      return null;
    },

    getSecondaryRole() {
      const roles = [...this.roles];

      let rolesArray = [];
      if (Array.isArray(roles) && roles.length > 0) {
        if (this.roles.includes('tenant')) {
          rolesArray.push(`${this.$t('user.admin.role.roleTenant')}`);
        }
        if (this.roles.includes('owner')) {
          rolesArray.push(`${this.$t('user.admin.role.roleOwner')}`);
        }
        if (this.roles.includes('familyMember')) {
          rolesArray.push(`${this.$t('user.admin.role.roleFamilyMember')}`);
        } 
        if (this.roles.includes('rentalManager')) {
          rolesArray.push(`${this.$t('user.admin.role.roleRentalManager')}`);
        } 

        if(rolesArray.length > 0) return rolesArray.join(', ');
      }
      return null;
    }
  }
}
</script>

<style>
  .quick-link__arrow {
    padding: 0 0 0 5px;
    font-size: 10px;
    vertical-align: middle;
    cursor: pointer;
  }
  .housingContent{font-size: small};
</style>